const interval = setInterval(() => {
  const input = document.querySelector("#bss-b2b-register-form #password");
  if (input) {
    input.placeholder = "Password";
    clearInterval(interval);
  }
  const helpTexts = document.querySelectorAll(".bss-b2b-rf-tooltip-text");

  helpTexts.forEach(helpText => {
  const nearestField = helpText.closest(".bss-b2b-rf-field");

  if (nearestField) {
    nearestField.insertAdjacentElement("beforeend", helpText);
  }
});

}, 300); 
 setTimeout(() => {
    clearInterval(interval)
 }, 6000);